export default "__VITE_ASSET__7d661c9e__"